<template>
    <div>
        <div :class="badgesClass">
            <ul ref="list" class="badges__list">
                <li v-for="(element, index) in listElements" :key="index" ref="badge" class="badges__badge">
                    <span>{{ element }}</span>
                </li>
            </ul>

            <div
                v-if="moreCount > 0"
                class="badges__more-indicator"
                @mouseover="openOnHover ? (isShowMoreOpen = true) : null"
                @mouseleave="openOnHover ? (isShowMoreOpen = false) : null"
                @click="toggleMoreBadges"
            >
                <span>+ {{ moreCount }}</span>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            listElements: { type: Array, required: true },
            openOnHover: { type: Boolean, default: false },
        },

        data() {
            return {
                moreCount: 0,
                isShowMoreOpen: false,
            }
        },

        computed: {
            badgesClass() {
                return {
                    badges: true,
                    badges__expanded: this.isShowMoreOpen,
                }
            },
        },

        methods: {
            calculateMore() {
                this.$nextTick(() => {
                    const allListElements = this.$refs.badge
                    const visibleListElements = []

                    if (!Array.isArray(allListElements)) {
                        return
                    }

                    for (const plan of allListElements) {
                        if (plan.offsetTop === 10) {
                            visibleListElements.push(plan)
                        }
                    }

                    this.moreCount = allListElements.length - visibleListElements.length
                })
            },

            toggleMoreBadges() {
                this.isShowMoreOpen = !this.isShowMoreOpen
            },
        },

        watch: {
            moreCount(newValue, oldValue) {
                if (newValue !== oldValue) {
                    this.calculateMore()
                }
            },
        },

        mounted() {
            this.calculateMore()
            window.addEventListener('resize', this.calculateMore)
        },

        beforeDestroy() {
            window.removeEventListener('resize', this.calculateMore)
        },
    }
</script>
